import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PAYROLLCOMPONENT,
  DELETE_PAYROLLCOMPONENT,
  UPDATE_PAYROLLCOMPONENT,
  ADD_NEW_PAYROLLCOMPONENT,
} from "./actionType";

import {
  getPayrollComponentSuccess,
  getPayrollComponentFail,
  deletePayrollComponentSuccess,
  deletePayrollComponentFail,
  updatePayrollComponentSuccess,
  updatePayrollComponentFail,
  addPayrollComponentSuccess,
  addPayrollComponentFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approvePayrollComponentApi,
  getPayrollComponentApi,
  updatePayrollComponentApi,
  deletePayrollComponentApi,
  addNewPayrollComponentApi
} from "../../helpers/backend_helper";

function* getPayrollComponent({ payload: payrollComponent }) {
  try {
    const response = yield call(getPayrollComponentApi, payrollComponent);
    yield put(getPayrollComponentSuccess(GET_PAYROLLCOMPONENT, response.data));
  } catch (error) {
    yield put(getPayrollComponentFail(GET_PAYROLLCOMPONENT, error));
  }
}

function* onUpdatePayrollComponent({ payload: payrollComponent }) {
  try {
    if (payrollComponent.setApprove) {
      const response = yield call(approvePayrollComponentApi, payrollComponent);
      yield put(updatePayrollComponentSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updatePayrollComponentApi, payrollComponent);
      yield put(updatePayrollComponentSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updatePayrollComponentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePayrollComponent({ payload: payrollComponent }) {
  try {
    const response = yield call(deletePayrollComponentApi, payrollComponent);
    yield put(deletePayrollComponentSuccess({ payrollComponent, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePayrollComponentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPayrollComponent({ payload: payrollComponent }) {
  try {
    const response = yield call(addNewPayrollComponentApi, payrollComponent);
    yield put(addPayrollComponentSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPayrollComponentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPayrollComponent() {
  yield takeEvery(GET_PAYROLLCOMPONENT, getPayrollComponent);
}

export function* watchUpdatePayrollComponent() {
  yield takeEvery(UPDATE_PAYROLLCOMPONENT, onUpdatePayrollComponent);
}

export function* watchDeletePayrollComponent() {
  yield takeEvery(DELETE_PAYROLLCOMPONENT, onDeletePayrollComponent);
}

export function* watchAddNewPayrollComponent() {
  yield takeEvery(ADD_NEW_PAYROLLCOMPONENT, onAddNewPayrollComponent);
}

function* payrollComponentSaga() {
  yield all([
    fork(watchGetPayrollComponent),
    fork(watchDeletePayrollComponent),
    fork(watchUpdatePayrollComponent),
    fork(watchAddNewPayrollComponent)
  ]);
}

export default payrollComponentSaga;
